import tippy from 'tippy.js';

export default function (Alpine) {
    Alpine.directive('tippy', (el, { expression, value }, { evaluateLater, evaluate, effect, cleanup }) => {
        tippy(el);
    });
}
